import type { Core } from '@form-validation/core'

// Table cells depend on other cells, so cached per-field results cannot be reused.
export function tableValidationLifecycle(
  validation: Pick<Core, 'updateFieldStatus' | 'revalidateField'>,
  tables: string[][],
) {
  const attempted = new Set<string[]>()
  return {
    attempt(fieldNames: string[]) {
      for (const table of tables) {
        if (table.some(name => fieldNames.includes(name))) attempted.add(table)
      }
      for (const name of fieldNames) validation.updateFieldStatus(name, 'NotValidated')
    },
    async changed(fieldName: string) {
      const table = tables.find(names => names.includes(fieldName))
      if (!table || !attempted.has(table)) return
      await Promise.all(table.map(name => validation.revalidateField(name)))
    },
  }
}
